import { useMemo } from "react";
import { useEffect, useState } from "react";
import SeniorenplatformItem from "../SeniorenplatformItem/SeniorenplatformItem"
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import { Loading } from "../../FicheLijst/Loading/Loading";

export const SeniorenplatformRelevantLeveledExercises = (props) => {

    const [relativeExercises, setRelativeExercises] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        if (props.entry.folderId) {
            fetch(`/umbraco/api/seniorenplatform/GetRelevantLeveledExercises?poId=${props.poId}&folderId=${props.entry.folderId}&exerciseGroup=${props.entry.exerciseGroup}&difficultyLevel=${props.entry.difficultyLevel}`)
                .then(response => {
                    var data = response.json();
                    data.then(data => {
                        setRelativeExercises(data);
                        setIsLoading(false);
                        data.length === 0 ? this.props.updateShowLeveledExercisesComponent(false) : '';
                    }).catch(error => {
                        console.log(error);
                        setRelativeExercises(null);
                        setIsLoading(false);
                    });
                })
                .catch(() => {
                    console.error("Error while fetching data");
                    setRelativeExercises(null);
                    setIsLoading(false);
                });
        }
    }, [props.folderId, props.entry.id])  

    const relevantCards = useMemo(() => {
        if (relativeExercises) {
            return relativeExercises.map((exercise, index) => {               
                if (exercise) {
                    return <SeniorenplatformItem
                        item={exercise}
                        key={index}
                        dictionary={props.dictionary}
                        toggleIsFavorites={props.toggleIsFavorites}
                        getDetailsOfItem={props.getDetailsOfItem}
                        isTechnicalExercise={true} />
                }
            }
            );
        }
    }, [JSON.stringify(relativeExercises), JSON.stringify(props.entries)]);

    const relevantSliderItems = useMemo(() => {
        if (relativeExercises) {
            return relativeExercises.map((item, index) => {                
                if (item) {
                    return <SwiperSlide key={index}>
                        <SeniorenplatformItem
                            item={item}
                            key={index}
                            dictionary={props.dictionary}
                            toggleIsFavorites={props.toggleIsFavorites}
                            getDetailsOfItem={props.getDetailsOfItem}
                            isTechnicalExercise={true} />
                    </SwiperSlide>
                }
            }
            )
        }
    }, [JSON.stringify(relativeExercises)]);

    return relevantCards ? (
        !isLoading ? <div className="c-senioren__detail__exercises c-senioren__detail__technical-exercises">        <h3>
            {props.dictionary.readyForNextLevel}
        </h3>
        <div className="c-senioren__detail__exercises__swiper">
            <Swiper
                spaceBetween={50}
                slidesPerView={1.5}
            >
                {relevantSliderItems}
            </Swiper>
        </div>
        <div className="c-senioren__detail__exercises__items">
            {relevantCards}
        </div>
    </div>
    : <Loading/>
    )
        : null

}